import { render, staticRenderFns } from "./ClaimProduct.vue?vue&type=template&id=053716d5&scoped=true&"
import script from "./ClaimProduct.vue?vue&type=script&lang=ts&"
export * from "./ClaimProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimProduct.vue?vue&type=style&index=0&id=053716d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053716d5",
  null
  
)

export default component.exports